<!-- eslint-disable -->
<template lang="pug">
    .modal-box
        .modal-box__background
        .modal-box__content
            .content__loader
                img(src="../../assets/images/battles/loader.png")
            .content__text {{ text }}
</template>

<script>
    /*eslint-disable*/
    export default {
        props: {
            isLastGameInBattle: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            text() {
                return this.isLastGameInBattle ?
                    this.$i18n.t('battle.battle_calculatingAnswers') :
                    this.$i18n.t('battle.battle_calculatingAnswersAfterGame')
            }
        }
    }
</script>

<style scoped lang="scss">
    .modal-box {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        z-index: 1;
        overflow: auto;
        @media screen and (max-width: 575px) {
            height: 100%;
        }
    }
    .modal-box__background {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(51, 51, 51, 0.2);
        backdrop-filter: blur(10px);
        border-radius: 40px;
        @media screen and (max-width: 575px) {
            border-radius: 0;
        }
    }
    .modal-box__content {
        background: #F7F7FF;
        border-radius: 20px;
        width: 90%;
        height: 100%;
        max-height: 170px;
        max-width: 600px;
        z-index: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .content__loader {
        width: 60px;
        height: 60px;
        margin: 0 auto;
        animation: spin 2s linear infinite;
    }
    @keyframes spin {
        100% {
            transform: rotate(360deg);
        }
    }
    .content__text {
        font-family: Rubik;
        font-style: normal;
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        color: #333333;
        margin-top: 15px;
    }
</style>
